module.exports = __webpack_public_path__ + "static/ondrej-0d2d915ba2e44762ea06f4eaaf260da2.png";